<template>

	<div class="list-content">
		<ul class=" type-support">

			<li v-for="(item, index) in noticeList" :id="'item-' + item.idx" @click="goView(item)">
				<div class="no">{{ item.idx }}</div>
				<div class="cate bedge-line">
					<span class="prim">{{ item.cateName }}</span>
					<span class="sec" v-if="item.isNotice">공지</span>
				</div>
				<div :style="{ color : item.opt3 }" class="tit">
					<a href="javascript:;" @click="goView(item)">{{ item.cateName }} {{ item.title }}</a>
				</div>
				<div class="rel">
					<span class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</span>
					<span class="date"><span class="blind">작성일</span>{{ item.createDate | datetimeFilter }}</span>
					<span class="state" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
						<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' : !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
					</span>
				</div>
			</li>

			<li v-for="(item, index) in boardList" :id="'item-' + item.idx" @click="goView(item)">
				<div class="no">{{ item.idx }}</div>
				<div class="cate bedge-line">
					<span class="prim">{{ item.cateName }}</span>
					<span class="sec" v-if="item.isNotice">공지</span>
				</div>
				<div :style="{ color : item.opt3 }" class="tit">
					<a href="javascript:;" @click="goView(item)">{{ item.title }}</a>
				</div>
				<div class="rel">
					<span class="auth" v-if="!boardInfo.isAnonymous"><span class="blind">작성자</span>{{ item.writerDec }}</span>
					<span class="date"><span class="blind">작성일</span>{{ item.createDate | datetimeFilter }}</span>
					<span class="state" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
						<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' : !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
					</span>
				</div>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "listClassic",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
		'boardList': (newVal, oldVal) => {
			//console.log( newVal )
		}
	}
}
</script>

<style scoped>

</style>